import { jsx as e } from "react/jsx-runtime";
import { forwardRef as b } from "react";
import h from "./index.es707.js";
import { BasicSelectBox as u } from "./index.es708.js";
import { LabeledField as D } from "./index.es494.js";
const F = "select-box", C = b(
  ({
    label: l,
    LeftIcon: c,
    size: m = "default",
    value: f,
    placeholder: i = "Select",
    required: a,
    feedback: s,
    asterix: n,
    disabled: o,
    isError: t,
    isOpen: p = !1,
    testId: r = F,
    infoTooltip: x,
    entityColor: S,
    colorIndicator: d,
    onClearClick: B,
    showClearIndicator: T,
    isLocked: E,
    ...L
  }, _) => /* @__PURE__ */ e("div", { className: h.container, ...L, ref: _, children: /* @__PURE__ */ e(
    D,
    {
      label: l,
      required: a,
      feedback: s,
      asterix: n,
      disabled: o,
      isError: t,
      testId: `${r}-label`,
      infoTooltip: x,
      children: /* @__PURE__ */ e(
        u,
        {
          isOpen: p,
          LeftIcon: c,
          size: m,
          value: f,
          placeholder: i,
          disabled: o,
          isError: t,
          testId: r,
          entityColor: S,
          colorIndicator: d,
          onClearClick: B,
          showClearIndicator: T,
          isLocked: E
        }
      )
    }
  ) })
);
export {
  F as SELECT_BOX_DEFAULT_TESTID,
  C as SelectBox
};
//# sourceMappingURL=index.es38.js.map
